import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import OrdersList from './OrdersList';

export default styled(OrdersList)`
  width: 100%;
  margin: 0 auto;
  padding: ${gridSizes('L')} ${gridSizes('L')};
  padding-bottom: 0;
  height: 100%;
  overflow: visible;
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  ${media.lessThan('extraSmall')`
  padding: ${gridSizes('L')} ${gridSizes('S')};
  padding-bottom: 0;
  `};

  h1 {
    font-size: ${gridSizes('L')};
    font-weight: ${weights('medium')};
  }
  .sectionHeader {
    font-weight: ${weights('medium')};
    &:first-letter {
      text-transform: uppercase;
    }
  }
  .orders-list {
    margin: 0;
    padding: 0;
    list-style: none;

    a {
      text-decoration: none;
    }
  }
`;
